<template>
  <li class="menu-item">
    <a v-if="!route" href="#" class="item-link" @click="onClickItem" :class="linkClasses">
      <div class="item-prepend">
        <slot name="prepend">
          <img v-if="icon" :src="getImg" class="item-icon"/>
        </slot>
      </div>
      <div class="item-text">
        <slot>
          {{ label }}
        </slot>
      </div>
      <div class="item-append">
        <slot name="append">
          <span v-if="badge !== undefined" class="e-badge" :class="badge.class || []">{{ badge.value || badge }}</span>
        </slot>
      </div>
    </a>
    <router-link v-if="route"
                 :to="typeof route === 'string' ? {name: route} : route"
                 class="item-link"
                 active-class="active"
                 :class="linkClasses"
                 @click="onClickItem">
      <div class="item-prepend">
        <slot name="prepend">
          <img v-if="icon" :src="getImg" class="item-icon"/>
        </slot>
      </div>
      <div class="item-text">
        <slot>
          <span>{{ label }}</span>
        </slot>
      </div>
      <div class="item-append">
        <slot name="append">
          <span v-if="badge !== undefined" class="e-badge" :class="badge.class || []">{{ badge.value || badge }}</span>
        </slot>
      </div>
    </router-link>
  </li>
</template>

<script>
	export default {
		name: "e-menu-item",
    props: {
      badge: {
        validator: (value) => {
          return typeof value === 'object' || typeof value === 'string';
        }
      },
      route: {
        validator: (value) => {
          return typeof value === 'object' || typeof value === 'string';
        }
      },
      icon: String,
      label: String,
      linkClass: String,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    methods: {
		  onClickItem() {
        this.$emit('click');
      }
    },
    computed: {
      getImg() {
        return require(`../../../assets/icons/${this.icon}.svg`);
      },
		  linkClasses() {
		    let classes =  {
          'disabled': this.disabled,
		    };

		    if(this.$props.linkClass) {
		      classes[this.$props.linkClass] = true;
        }

        return classes;
      }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/sidebar/menuItem.vue